import ViewCounter from "../../js/modules/viewCount";

export default function (newsId, serviceDns) {
    new ViewCounter({
        selector: '#views-counter-' + newsId,
        entityKey: newsId,
        apiDns: serviceDns
    })
}